import React from 'react';

interface MedicalDisclaimerProps {
  /** Дополнительный текст дисклеймера (опционально) */
  extraText?: string;
  /** Размер баннера: 'compact' | 'full' (по умолчанию 'full') */
  size?: 'compact' | 'full';
}

const COLORS = {
  bg: '#0a0814',
  warningBg: 'rgba(255, 82, 82, 0.12)',
  warningBorder: '#FF5252',
  warningIcon: '#FF5252',
  text: '#e0e0e0',
  textMuted: '#b0b0b0',
  gold: '#d4af37',
  goldLight: '#f4e4a6',
};

const MedicalDisclaimer: React.FC<MedicalDisclaimerProps> = ({
  extraText,
  size = 'full',
}) => {
  const padding = size === 'compact' ? '12px 16px' : '20px 24px';
  const fontSize = size === 'compact' ? '13px' : '14px';
  const iconSize = size === 'compact' ? '20px' : '28px';

  return (
    <div
      style={{
        background: COLORS.warningBg,
        border: `2px solid ${COLORS.warningBorder}`,
        borderLeft: `5px solid ${COLORS.warningBorder}`,
        borderRadius: '12px',
        padding,
        marginBottom: size === 'full' ? '32px' : '16px',
        fontFamily: 'var(--font-sans)',
      }}
    >
      <div style={{ display: 'flex', gap: '12px', alignItems: 'flex-start' }}>
        <span style={{ fontSize: iconSize, flexShrink: 0, color: COLORS.warningIcon }}>
          &#9888;&#65039;
        </span>
        <div>
          <div
            style={{
              fontSize: size === 'compact' ? '14px' : '16px',
              fontWeight: 700,
              color: COLORS.warningBorder,
              marginBottom: '8px',
              fontFamily: 'var(--font-display)',
            }}
          >
            Медицинский дисклеймер
          </div>
          <p
            style={{
              margin: '0 0 8px 0',
              color: COLORS.text,
              fontSize,
              lineHeight: 1.6,
            }}
          >
            Данный анализ носит информационный характер и основан на традициях медицинской
            астрологии. Он <strong style={{ color: COLORS.warningBorder }}>не заменяет</strong>{' '}
            консультацию квалифицированного врача и{' '}
            <strong style={{ color: COLORS.warningBorder }}>не является медицинской рекомендацией</strong>.
          </p>
          <p
            style={{
              margin: 0,
              color: COLORS.goldLight,
              fontSize,
              lineHeight: 1.6,
              fontStyle: 'italic',
            }}
          >
            При любых симптомах или проблемах со здоровьем обращайтесь к лицензированному
            медицинскому специалисту.
          </p>
          {extraText && (
            <p
              style={{
                margin: '8px 0 0 0',
                color: COLORS.textMuted,
                fontSize: '12px',
                lineHeight: 1.5,
              }}
            >
              {extraText}
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default MedicalDisclaimer;
